export default "__VITE_ASSET__DZo11CDD__"